import React from 'react';
import PropTypes from 'prop-types';
import {
  Sharebelt,
  ShareBeltPrint,
  ShareBeltShareButton,
  ShareFavorite
} from '@thd-olt-component-react/thd-sharebelt';
import { extend } from '@thd-nucleus/data-sources';

export const PIPSharebelt = ({
  itemId,
  showShareBeltPrint,
  showShareBeltShareButton,
  hideAddToList,
  showShareBeltLabels,
  showFavoritesCount
}) => {
  return (
    <div data-testid="sharabelt-product-details" className="sui-absolute sui-top-4 sui-right-4">
      <Sharebelt itemId={itemId}>
        {!hideAddToList && (
          <ShareFavorite showCircle showFavoritesCount={showFavoritesCount} />
        )}
        {showShareBeltShareButton && (
          <ShareBeltShareButton email hideLabel={!showShareBeltLabels} />
        )}
        {showShareBeltPrint && (
          <ShareBeltPrint hideLabel={!showShareBeltLabels} />
        )}
      </Sharebelt>
    </div>
  );
};
PIPSharebelt.propTypes = {
  itemId: PropTypes.string.isRequired,
  showShareBeltPrint: PropTypes.bool,
  showShareBeltShareButton: PropTypes.bool,
  hideAddToList: PropTypes.bool,
  showShareBeltLabels: PropTypes.bool,
  showFavoritesCount: PropTypes.bool,
};
PIPSharebelt.defaultProps = {
  showShareBeltPrint: false,
  showShareBeltShareButton: false,
  hideAddToList: false,
  showShareBeltLabels: false,
  showFavoritesCount: false
};

PIPSharebelt.displayName = 'PIPSharebelt';

PIPSharebelt.dataModel = extend(Sharebelt);
